import { render } from "./SmartMobileProject.vue?vue&type=template&id=6e264e21&scoped=true"
const script = {}

import "./SmartMobileProject.vue?vue&type=style&index=0&id=6e264e21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e264e21"]])

export default __exports__